/** Extract embed URL for YouTube or Vimeo. Returns null if not supported. */
export function getVideoEmbedUrl(url: string): string | null {
  const s = url.trim();
  // YouTube: youtube.com/watch?v=ID, youtu.be/ID
  const ytMatch = s.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
  // Vimeo: vimeo.com/ID
  const vimeoMatch = s.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
  return null;
}
